
import React from 'react';

export const PhotoIcon: React.FC<{ className?: string }> = ({ className }) => (
  <span className={`material-symbols-outlined ${className}`}>
    image
  </span>
);